module.exports = __webpack_public_path__ + "static/media/providence-1.c21af3db.jpg";